import { render, staticRenderFns } from "./IconNoOper.vue?vue&type=template&id=60a8afc6"
import script from "./IconNoOper.vue?vue&type=script&lang=js"
export * from "./IconNoOper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports